<template>
  <div>
    <div v-if="currentFile">
      <div>
        <v-progress-linear
          v-model="progress"
          color="light-blue"
          height="25"
          reactive
        >
          <strong>{{ progress }} %</strong>
        </v-progress-linear>
      </div>
    </div>

    <v-row no-gutters justify="center" align="center">
      <v-col cols="8">
        <v-file-input
          show-size
          label="File input"
          @change="selectFile"
        ></v-file-input>
      </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>

    <v-card class="mx-auto">
      <v-toolbar
        color="#81DBF6"
        dark dense
        elevation="0"
      >

        <v-toolbar-title>Images</v-toolbar-title>
      </v-toolbar>

      <v-list dense two-line subheader>
        <v-list-item
          v-for="images in allImages"
          :key="images.id"
        >
          <v-list-item-content>
            <v-list-item-title v-text="images.name"></v-list-item-title>
            <v-list-item-subtitle v-text="images.type"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn @click="setCurrent(images)" icon small dark :color="images.isCurrent? 'success' : 'grey'" >
              <v-icon>mdi-check-circle</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

      </v-list>
    </v-card>
  </div>
</template>

<script>
import UploadService from "../services/upload.service";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "upload-files",
  data() {
    return {
      currentFile: undefined,
      progress: 0,
      message: "",

      fileInfos: []
    };
  },

  computed: {
    ...mapGetters([
      "allImages"
    ])
  },

  methods: {
    ...mapActions([
      "updateImage"
    ]),

    setCurrent(item) {
      this.updateImage(item)
      .then(response => {
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    selectFile(file) {
      this.progress = 0;
      this.currentFile = file;
    },

    upload() {
      if (!this.currentFile) {
        this.message = "Please select a file!";
        return;
      }

      this.message = "";

      UploadService.uploadImage(this.currentFile, (event) => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      })
        .then((response) => {
          this.message = response.data.message;
          return UploadService.getFiles();
        })
        .then((files) => {
          this.fileInfos = files.data;
        })
        .catch(() => {
          this.progress = 0;
          this.message = "Could not upload the file!";
          this.currentFile = undefined;
        });
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    UploadService.getFiles().then(response => {
      this.fileInfos = response.data;
    });
  }
};
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>